import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MainLayout from "./components/layout/MainLayout";
import { DashboardPage, LoginPage } from "./pages";
import LoadingPage from "./pages/auth/LoadingPage";
import SignupPage from "./pages/auth/SignupPage";
import BetHistoryPage from "./pages/bet/BetHistoryPage";
import MatchDetailsPage from "./pages/match/MatchDetailsPage";
import Terms from "./pages/Terms";
import BottomNav from "./components/layout/BottomNav";
import ProfilePage from "./pages/profile/ProfilePage";
import WalletPage from "./pages/wallet/WalletPage";
import DepositPage from "./pages/wallet/DepositPage";
import WithdrawPage from "./pages/wallet/WithdrawPage";

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<LoadingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<SignupPage />} />
          <Route element={<MainLayout />}>
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/match/:id" element={<MatchDetailsPage />} />
            <Route path="/bet-history" element={<BetHistoryPage />} />
            <Route path="/account" element={<ProfilePage />} />
            <Route path="/wallet" element={<WalletPage />} />
            <Route path="/deposit" element={<DepositPage />} />
            <Route path="/withdraw" element={<WithdrawPage />} />
          </Route>
          <Route path="/terms" element={<Terms />} />
          <Route path="/bet-history" element={<BetHistoryPage />} />
        </Routes>
        <BottomNav /> {/* Moved inside Router */}
      </Router>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        theme="dark"
        limit={4}
      />
    </>
  );
}

export default App;
